import yup from 'src/libraries/validator.library';

export const AirDropsSchema = yup
  .object({
    dispatchId: yup.number(),
    recordId: yup.number(),
    dipCount: yup.number(),
    dropCount: yup.number(),
    waterLiters: yup.number(),
    waterGallons: yup.number(),
  })
  .defined();

const FireDispatchShape = {
  burnedAcres: yup.string().nullable(),
  FHRemainder: yup.string().nullable(),
  FHRemainderHrs: yup.string().nullable(),
  FHRemainderMins: yup.string().nullable(),
  GPSCoordinates: yup.string().nullable(),
  SDGEHrs: yup.string().nullable(),
  SDGEMins: yup.string().nullable(),
  agencyHrs: yup.string().nullable(),
  agencyMins: yup.string().nullable(),
  billableLaunch: yup.string().nullable(),
  coPilot: yup.string().nullable(),
  countyHrs: yup.string().nullable(),
  countyMins: yup.string().nullable(),
  dipCount: yup.string().nullable(),
  dispatchDate: yup.string().nullable(),
  dispatchId: yup.number().nullable(),
  dispatchTime: yup.string().nullable(),
  dropCount: yup.string().nullable(),
  enteredBy: yup.string().nullable(),
  entryDate: yup.string().nullable(),
  fireAgency: yup.string().nullable(),
  fireFundAgency: yup.string().nullable(),
  fireFundCounty: yup.string().nullable(),
  fireFundSDGE: yup.string().nullable(),
  fireName: yup.string().nullable(),
  flightHours: yup.string().nullable(),
  flightHrs: yup.string().nullable(),
  flightMins: yup.string().nullable(),
  flightNumber: yup.string().nullable(),
  flightReason: yup.string().nullable(),
  fuelCycles: yup.number().nullable(),
  landingCycles: yup.number().nullable(),
  lattitude: yup.string().nullable(),
  liftoffTime: yup.string().nullable(),
  location: yup.string().nullable(),
  lockFlag: yup.string().nullable(),
  longitude: yup.string().nullable(),
  operatorID: yup.number().nullable(),
  operatorName: yup.string().nullable(),
  pilot: yup.string().nullable(),
  reason: yup.string().nullable(),
  reasonBy: yup.string().nullable(),
  reasonDate: yup.string().nullable(),
  responseTime: yup.string().nullable(),
  returnTime: yup.string().nullable(),
  status: yup.string().nullable(),
  tailNumber: yup.string().nullable(),
  updateDate: yup.string().nullable(),
  updatedBy: yup.string().nullable(),
  waterGallons: yup.string().nullable(),
  water_Liters: yup.string().nullable(),
};

const FireDispatchReportShape = {
  dispatchId: yup.number(),
  dispatchDate: yup.date().nullable(),
  dispatchYear: yup.number().nullable(),
  dispatchTime: yup.string().nullable(),
  liftoffTime: yup.string().nullable(),
  responseTime: yup.string().nullable(),
  returnTime: yup.string().nullable(),
  flightHrs: yup.number().nullable(),
  totalFlightHrs: yup.number().nullable(),
  totalFlightHrsUnbilled: yup.number().nullable(),
  unbilledTotal: yup.number().nullable(),
  sdgeBalance: yup.number().nullable(),
  unbilledActual: yup.number().nullable(),
  sdgeHrs: yup.number().nullable(),
  sdgeCharges: yup.string().nullable(),
  countyHrs: yup.number().nullable(),
  countyBilled: yup.number().nullable(),
  agencyHrs: yup.number().nullable(),
  agencyBilled: yup.number().nullable(),
  billableLaunch: yup.string().nullable(),
  dipCount: yup.string().nullable(),
  waterGallons: yup.string().nullable(),
  fireName: yup.string().nullable(),
  burnedAcres: yup.string().nullable(),
  agencyName: yup.string().nullable(),
  status: yup.string().nullable(),
};

export const FireDispatchFiltersSchema = yup
  .object({
    districts: yup.array().of(yup.string()),
    requestStatuses: yup.array().of(yup.string()),
    flightTypes: yup.array().of(yup.string()),
    operatorNames: yup.array().of(yup.string()),
    tailNumbers: yup.array().of(yup.string()),
    requestorNames: yup.array().of(yup.string()),
    tarStatuses: yup.array().of(yup.string()),
    fireAgencies: yup.array().of(yup.string()),
  })
  .defined();

export const FireDispatchSchema = yup
  .object()
  .shape({
    ...FireDispatchShape,
  })
  .defined();

export const FireDispatchReportListSchema = yup
  .object({
    report: yup
      .object({
        count: yup.number(),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                ...FireDispatchReportShape,
              })
              .defined()
          )
          .defined(),
      })
      .defined(),
  })
  .defined();

export const FireDispatchListSchema = yup
  .object({
    fireDispatch: yup
      .object({
        counts: yup.object({
          all: yup.number(),
          dispatched: yup.number(),
          inFlight: yup.number(),
          landed: yup.number(),
          cancelled: yup.number(),
          completed: yup.number(),
        }),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                ...FireDispatchShape,
              })
              .defined()
          )
          .defined(),
      })
      .defined(),
  })
  .defined();

export const FireDispatchEmailPayloadSchema = yup
  .object({
    errorEmails: yup.array().of(yup.string()),
    errorMessage: yup.string(),
    reqMessage: yup.string(),
    reqStatus: yup.boolean(),
    statusCode: yup.number(),
    successfulEmails: yup.array().of(yup.string()),
  })
  .defined();

export const FireDispatchEmailBodySchema = yup
  .object({
    toEmailIds: yup.array().of(yup.string().defined()).defined().required(),
    from: yup.string(),
    subjectLine: yup.string().defined().required(),
    coverLetter: yup.string().defined(),
    eMailBody: yup.string().defined(),
    attachments: yup.array().of(yup.string()).optional(),
  })
  .defined();

export type IFireDispatch = yup.InferType<typeof FireDispatchSchema>;
export type IFireDispatchList = yup.InferType<typeof FireDispatchListSchema>;
export type IFireDispatchFilters = yup.InferType<
  typeof FireDispatchFiltersSchema
>;
export type IFireDispatchEmailFormat = yup.InferType<
  typeof FireDispatchEmailBodySchema
>;
